import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';

export const userAccountsApi = createApi({
  reducerPath: 'userAccountsApi',
  baseQuery,
  tagTypes: ['User'],
  endpoints: builder => ({
    getUsers: builder.query<any, { search: string }>({
      query: ({ search }) => `/auth/users?q=${search}`,
      providesTags: ['User'],
    }),
    getUser: builder.query<any, string>({
      query: (id) => `/auth/users/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'User', id }],
    }),
    createUser: builder.mutation<any, any>({
      query: newUser => ({
        url: '/auth/users',
        method: 'POST',
        body: newUser,
      }),
      invalidatesTags: ['User'],
    }),
    updateUser: builder.mutation<any, { id: number; updates: any }>({
      query: ({ id, updates }) => ({
        url: `/auth/users/${id}`,
        method: 'PATCH',
        body: updates,
      }),
      async onQueryStarted({ id, updates }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          userAccountsApi.util.updateQueryData(
            'getUsers',
            { search: '' },
            draft => {
              const usersArray = draft as any;
              const userToUpdate = usersArray.find(
                (user: any) => user.id === id
              );
              if (userToUpdate) {
                Object.assign(userToUpdate, updates);
              }
            }
          )
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: (_, __, { id }) => [{ type: 'User', id }, 'User'],
    }),
    resetUserPassword: builder.mutation<any, { userId: number }>({
      query: ({ userId }) => ({
        url: `/auth/users/${userId}/reset`,
        method: 'POST',
      }),
      invalidatesTags: ['User'],
    }),
    deactivateUser: builder.mutation<any, { userId: number }>({
      query: ({ userId }) => ({
        url: `/auth/users/${userId}`,
        method: 'PATCH',
        body: { status: 'inactive' },
      }),
      invalidatesTags: ['User'],
    }),
    activateUser: builder.mutation<any, { userId: number }>({
      query: ({ userId }) => ({
        url: `/auth/users/${userId}`,
        method: 'PATCH',
        body: { status: 'active' },
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetUserQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useResetUserPasswordMutation,
  useDeactivateUserMutation,
  useActivateUserMutation,
} = userAccountsApi;
